export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_CART = 'SET_CART';
export const SET_DATE = 'SET_DATE';
export const SET_SERVICE_TYPE = 'SET_SERVICE_TYPE';
export const SET_SCRIPT_LOADED = 'SET_SCRIPT_LOADED';
export const SET_CATERING_DISPLAY = 'SET_CATERING_DISPLAY';
export const FETCH_ZONE_ERROR = 'FETCH_ZONE_ERROR';
export const FETCH_ZONE_SUCCESS = 'FETCH_ZONE_SUCCESS';
export const SET_SHOW_NO_SERVICE = 'SET_SHOW_NO_SERVICE';
